<div class="org-list-container">
    <div class="org-list-container-inner">
        <org-list *ngFor="let orgList of orgTree" 
                  [orgList]="orgList" 
                  (orgAdded)="onOrgAdd($event)" 
                  (orgCollapsed)="onOrgCollapsed($event)" 
                  (orgExpanded)="onOrgExpanded($event)"></org-list>
    </div>
</div>